<script setup lang="ts">
import sanitizeHtml from 'sanitize-html';

const props = defineProps({
  tagWrapper: {
    type: String,
    default: 'div',
  },
  seotext: {
    type: String,
    required: true,
  },
  classWrapper: {
    type: [String, Array],
    default: '',
  },
});
const seoTextRender = () => {
  return h(props.tagWrapper, {
    class: props.classWrapper,
    innerHTML: props.seotext.includes('svg')
      ? props.seotext
      : sanitizeHtml(props.seotext, {
          allowedTags: [
            'address',
            'article',
            'aside',
            'footer',
            'header',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'hgroup',
            'main',
            'nav',
            'section',
            'blockquote',
            'dd',
            'div',
            'dl',
            'dt',
            'figcaption',
            'figure',
            'hr',
            'li',
            'main',
            'ol',
            'p',
            'pre',
            'ul',
            'a',
            'abbr',
            'b',
            'bdi',
            'bdo',
            'br',
            'cite',
            'code',
            'data',
            'dfn',
            'em',
            'i',
            'kbd',
            'mark',
            'q',
            'rb',
            'rp',
            'rt',
            'rtc',
            'ruby',
            's',
            'samp',
            'small',
            'span',
            'strong',
            'sub',
            'sup',
            'time',
            'u',
            'var',
            'wbr',
            'caption',
            'col',
            'colgroup',
            'table',
            'tbody',
            'td',
            'tfoot',
            'th',
            'thead',
            'tr',
          ],
        }),
  });
};
</script>

<template>
  <seoTextRender />
</template>

<style scoped lang="scss"></style>
